import React, { Component } from 'react'
import { GridLoader } from 'react-spinners';

export default class Spinner extends Component {
  render() {
    const css = {
      display:'block',
      margin: this.props.margin || '0 auto'
    }
    return (
      <>
        <GridLoader
          color={'#e53935'}
          css={css}
          size={this.props.size}
        />
      </>
    )
  }
}
